(function () {
  var activeClass = 'stylist-product-media-switcher__image--active';
  var hoverAttr = 'data-stylist-hover';
  var mobileCardQuery = window.matchMedia('(max-width: 749px)');
  var mobilePreviewHiddenAttr = 'data-stylist-mobile-preview-hidden';

  function shouldKeepControlsFocused(button) {
    return (
      window.matchMedia('(max-width: 749px), (hover: none), (pointer: coarse)').matches &&
      Boolean(button && button.closest && button.closest('.search-modal, product-card, .product-card'))
    );
  }

  function preserveOrReleaseControlFocus(button) {
    if (shouldKeepControlsFocused(button)) {
      button.focus({ preventScroll: true });
    } else {
      button.blur();
    }
  }

  function modulo(index, length) {
    return ((index % length) + length) % length;
  }

  function blurControls(root) {
    if (!root) return;
    root.querySelectorAll('.stylist-media-switcher__button, .stylist-card-media-button').forEach(function (button) {
      button.blur();
    });
  }

  function getCustomSwitcherFromButton(button) {
    var container = button.closest('.stylist-cart-media-container, .stylist-search-product__media-switcher');
    if (container && container.matches('[data-stylist-media-switcher]')) return container;
    if (container) return container.querySelector('[data-stylist-media-switcher]');
    return button.closest('[data-stylist-media-switcher]');
  }

  function getCustomHoverRoot(switcher) {
    return switcher.closest('.stylist-cart-media-container, .stylist-search-product-card') || switcher;
  }

  function getCustomImages(switcher) {
    return Array.prototype.slice.call(switcher.querySelectorAll('.stylist-product-media-switcher__image'));
  }

  function syncCustomSwitcher(switcher) {
    var images = getCustomImages(switcher);
    if (!images.length) return;

    var activeIndex = Number(switcher.dataset.activeIndex || '0');
    if (Number.isNaN(activeIndex)) activeIndex = 0;
    activeIndex = modulo(activeIndex, images.length);
    switcher.dataset.activeIndex = String(activeIndex);

    images.forEach(function (image, index) {
      var isActive = index === activeIndex;
      image.classList.toggle(activeClass, isActive);
      image.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      image.style.setProperty('opacity', isActive ? '1' : '0', 'important');
      image.style.setProperty('transform', 'none', 'important');
      image.style.setProperty('filter', 'none', 'important');
      image.style.setProperty('pointer-events', 'none', 'important');
      image.style.setProperty('transition', 'opacity 160ms ease', 'important');
      image.style.setProperty('z-index', isActive ? '2' : '1', 'important');
    });
  }

  function setCustomActive(switcher, index) {
    var images = getCustomImages(switcher);
    if (!switcher || images.length < 2) return;

    switcher.dataset.activeIndex = String(modulo(index, images.length));
    syncCustomSwitcher(switcher);
  }

  function prepareCustomSwitcher(switcher) {
    if (!switcher) return;

    if (!switcher.dataset.activeIndex) switcher.dataset.activeIndex = '0';
    syncCustomSwitcher(switcher);

    if (switcher.dataset.stylistMediaReady === 'true') return;
    switcher.dataset.stylistMediaReady = 'true';

    var hoverRoot = getCustomHoverRoot(switcher);
    if (!hoverRoot) return;

    hoverRoot.addEventListener('pointerenter', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      hoverRoot.setAttribute(hoverAttr, 'true');
      if (getCustomImages(switcher).length > 1) setCustomActive(switcher, 1);
    });

    hoverRoot.addEventListener('pointerleave', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      hoverRoot.removeAttribute(hoverAttr);
      setCustomActive(switcher, 0);
      blurControls(hoverRoot);
    });
  }

  function getProductCard(node) {
    return node && node.closest ? node.closest('product-card, .product-card') : null;
  }

  function getCardSlideshow(card) {
    if (!card) return null;
    if (card.refs && card.refs.slideshow) return card.refs.slideshow;
    return card.querySelector('slideshow-component');
  }

  function isMobileProductCard(card) {
    return Boolean(card && mobileCardQuery.matches);
  }

  function getAllCardSlides(card) {
    var slideshow = getCardSlideshow(card);
    if (!slideshow) return [];
    return Array.prototype.slice.call(slideshow.querySelectorAll('slideshow-slide'));
  }

  function normalizeCardActiveIndex(card, preferredSlide) {
    var slideshow = getCardSlideshow(card);
    if (!slideshow) return;

    var slides = getAllCardSlides(card).filter(function (slide) {
      return !slide.hasAttribute('hidden') && !slide.hasAttribute(mobilePreviewHiddenAttr);
    });
    var activeSlide = slides.indexOf(preferredSlide) >= 0
      ? preferredSlide
      : slides.find(function (slide) {
          return slide.getAttribute('aria-hidden') === 'false';
        });
    var activeIndex = slides.indexOf(activeSlide);
    if (!activeSlide || activeIndex < 0) return;

    card.dataset.stylistCardActiveIndex = String(activeIndex);
    if (typeof slideshow.select !== 'function' || slideshow.current === activeIndex) return;

    var slideId = activeSlide.getAttribute('slide-id');
    if (slideId) {
      slideshow.select({ id: slideId }, undefined, { animate: false });
    } else {
      slideshow.select(activeIndex, undefined, { animate: false });
    }
  }

  function syncMobileCardPreviewLimit(card) {
    var slideshow = getCardSlideshow(card);
    var allSlides = getAllCardSlides(card);
    if (!allSlides.length) return;

    var currentSlides = allSlides.filter(function (slide) {
      return !slide.hasAttribute('hidden') && !slide.hasAttribute(mobilePreviewHiddenAttr);
    });
    var currentSlide = slideshow && typeof slideshow.current === 'number'
      ? currentSlides[slideshow.current]
      : null;

    if (!isMobileProductCard(card)) {
      card.removeAttribute('data-stylist-mobile-preview-limit');
      allSlides.forEach(function (slide) {
        slide.removeAttribute(mobilePreviewHiddenAttr);
      });
      normalizeCardActiveIndex(card, currentSlide);
      return;
    }

    card.setAttribute('data-stylist-mobile-preview-limit', '2');

    var availableSlides = allSlides.filter(function (slide) {
      return !slide.hasAttribute('hidden');
    });
    var allowedSlides = availableSlides.slice(0, 2);
    var activeSlide = currentSlide || availableSlides.find(function (slide) {
      return slide.getAttribute('aria-hidden') === 'false';
    });

    // A selected variant image may live later in the source order. Preserve it
    // as one of the two previews while still keeping the total at two.
    if (activeSlide && allowedSlides.indexOf(activeSlide) === -1) {
      allowedSlides = [availableSlides[0], activeSlide].filter(Boolean);
    }

    var allowedSet = new Set(allowedSlides);
    allSlides.forEach(function (slide) {
      slide.toggleAttribute(
        mobilePreviewHiddenAttr,
        !slide.hasAttribute('hidden') && !allowedSet.has(slide)
      );
    });
    normalizeCardActiveIndex(card, activeSlide);
  }

  function getCardSlides(card) {
    return getAllCardSlides(card)
      .filter(function (slide) {
        return !slide.hasAttribute('hidden') && !slide.hasAttribute(mobilePreviewHiddenAttr);
      })
      .slice(0, 2);
  }

  function cleanCardMedia(card, activeIndex) {
    // Recommendation galleries use the theme slideshow's own visibility and
    // transitions. Inline neutralizers here previously removed their motion.
    if (isMobileProductCard(card)) return;

    var slides = getCardSlides(card);
    slides.forEach(function (slide, index) {
      var isActive = index === activeIndex;
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      slide.style.setProperty('opacity', '1', 'important');
      slide.style.setProperty('filter', 'none', 'important');
      slide.style.setProperty('transform', 'none', 'important');
      slide.style.setProperty('transition', 'none', 'important');
      slide.querySelectorAll('img, picture, video, .product-media, .product-media-container').forEach(function (media) {
        media.style.setProperty('opacity', '1', 'important');
        media.style.setProperty('filter', 'none', 'important');
        media.style.setProperty('transform', 'none', 'important');
        media.style.setProperty('transition', 'none', 'important');
      });
    });
  }

  function scrollCardToSlide(slide, behavior) {
    var scroller = slide ? slide.closest('slideshow-slides') : null;
    if (scroller) {
      scroller.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'auto' });
      return;
    }

    if (slide) {
      slide.scrollIntoView({ behavior: behavior || 'auto', block: 'nearest', inline: 'center' });
    }
  }

  function selectCardSlide(card, index) {
    var slides = getCardSlides(card);
    if (slides.length < 2) return;

    var nextIndex = modulo(index, slides.length);
    var slideshow = getCardSlideshow(card);
    var slide = slides[nextIndex];
    card.dataset.stylistCardActiveIndex = String(nextIndex);

    if (isMobileProductCard(card)) {
      if (slideshow && typeof slideshow.select === 'function') {
        // Keep the raw index here. Values -1 and slides.length are what let the
        // native slideshow animate through its established infinite-loop path.
        slideshow.select(index, undefined, { animate: true });
      } else {
        scrollCardToSlide(slide, 'smooth');
      }
      return;
    }

    if (slideshow && typeof slideshow.select === 'function') {
      var slideId = slide.getAttribute('slide-id');
      try {
        if (slideId) {
          slideshow.select({ id: slideId }, undefined, { animate: false });
        } else {
          slideshow.select(nextIndex, undefined, { animate: false });
        }
      } catch (error) {
        scrollCardToSlide(slide);
      }
    } else {
      scrollCardToSlide(slide);
    }

    scrollCardToSlide(slide);
    window.requestAnimationFrame(function () {
      scrollCardToSlide(slide);
      cleanCardMedia(card, nextIndex);
    });
  }

  function ensureCardControls(card) {
    var slides = getCardSlides(card);
    if (slides.length < 2) return;

    var gallery = card.querySelector('.card-gallery');
    if (!gallery || gallery.querySelector('.stylist-card-media-controls')) return;

    var controls = document.createElement('div');
    controls.className = 'stylist-media-switcher__controls stylist-card-media-controls';
    controls.setAttribute('aria-label', 'Product image controls');
    controls.innerHTML =
      '<button class="stylist-media-switcher__button stylist-card-media-button stylist-card-media-button--prev" type="button" data-stylist-card-media-prev aria-label="Previous image"><span aria-hidden="true">&larr;</span></button>' +
      '<button class="stylist-media-switcher__button stylist-card-media-button stylist-card-media-button--next" type="button" data-stylist-card-media-next aria-label="Next image"><span aria-hidden="true">&rarr;</span></button>';
    gallery.appendChild(controls);
  }

  function prepareProductCard(card) {
    if (!card) return;

    syncMobileCardPreviewLimit(card);

    if (card.dataset.stylistCardReady === 'true') {
      ensureCardControls(card);
      return;
    }

    if (getCardSlides(card).length < 2) return;
    ensureCardControls(card);
    card.dataset.stylistCardReady = 'true';
    card.dataset.stylistCardActiveIndex = '0';
    cleanCardMedia(card, 0);

    var slideshow = getCardSlideshow(card);
    if (isMobileProductCard(card) && slideshow) {
      slideshow.setAttribute('data-mobile-edge-loop', '');
      slideshow.setAttribute('data-mobile-single-step', '');
      slideshow.addEventListener('slideshow:select', function (event) {
        if (!event.detail || typeof event.detail.index !== 'number') return;
        card.dataset.stylistCardActiveIndex = String(event.detail.index);
      });
    }

    card.addEventListener('pointerenter', function (event) {
      if (isMobileProductCard(card)) return;
      if (event.pointerType && event.pointerType !== 'mouse') return;
      card.setAttribute(hoverAttr, 'true');
      selectCardSlide(card, 1);
    });

    card.addEventListener('pointerleave', function (event) {
      if (isMobileProductCard(card)) return;
      if (event.pointerType && event.pointerType !== 'mouse') return;
      card.removeAttribute(hoverAttr);
      selectCardSlide(card, 0);
      blurControls(card);
    });
  }

  function prepareAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-stylist-media-switcher]')) prepareCustomSwitcher(scope);
    scope.querySelectorAll('[data-stylist-media-switcher]').forEach(prepareCustomSwitcher);

    if (scope.matches && scope.matches('product-card, .product-card')) prepareProductCard(scope);
    scope.querySelectorAll('product-card, .product-card').forEach(prepareProductCard);
  }

  document.addEventListener(
    'click',
    function (event) {
      var cardButton = event.target && event.target.closest
        ? event.target.closest('[data-stylist-card-media-prev], [data-stylist-card-media-next]')
        : null;

      if (cardButton) {
        var card = getProductCard(cardButton);
        if (!card) return;

        event.preventDefault();
        event.stopPropagation();

        var cardCurrent = Number(card.dataset.stylistCardActiveIndex || '0');
        var cardDirection = cardButton.hasAttribute('data-stylist-card-media-prev') ? -1 : 1;
        card.dataset.userSwitched = 'true';
        card.setAttribute(hoverAttr, 'true');
        selectCardSlide(card, cardCurrent + cardDirection);
        preserveOrReleaseControlFocus(cardButton);
        return;
      }

      var button = event.target && event.target.closest
        ? event.target.closest('[data-stylist-media-prev], [data-stylist-media-next]')
        : null;
      if (!button) return;

      var switcher = getCustomSwitcherFromButton(button);
      if (!switcher) return;

      event.preventDefault();
      event.stopPropagation();

      var current = Number(switcher.dataset.activeIndex || '0');
      var direction = button.hasAttribute('data-stylist-media-prev') ? -1 : 1;
      switcher.dataset.userSwitched = 'true';
      getCustomHoverRoot(switcher).setAttribute(hoverAttr, 'true');
      setCustomActive(switcher, current + direction);
      preserveOrReleaseControlFocus(button);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      prepareAll(document);
    });
  } else {
    prepareAll(document);
  }

  mobileCardQuery.addEventListener('change', function () {
    document.querySelectorAll('product-card, .product-card').forEach(function (card) {
      syncMobileCardPreviewLimit(card);
      ensureCardControls(card);
    });
  });

  var pendingRoots = new Set();
  var prepareScheduled = false;

  function flushPendingRoots() {
    prepareScheduled = false;
    var roots = Array.from(pendingRoots).filter(function (root) {
      return root.isConnected;
    });
    pendingRoots.clear();

    roots.forEach(function (root) {
      var containedByAnotherRoot = roots.some(function (otherRoot) {
        return otherRoot !== root && otherRoot.contains(root);
      });
      if (!containedByAnotherRoot) prepareAll(root);
    });
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        var card = mutation.target.closest && mutation.target.closest('product-card, .product-card');
        if (card) pendingRoots.add(card);
        return;
      }

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) pendingRoots.add(node);
      });
    });

    if (!prepareScheduled && pendingRoots.size) {
      prepareScheduled = true;
      window.requestAnimationFrame(flushPendingRoots);
    }
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['hidden', 'initial-slide', 'reveal'],
    childList: true,
    subtree: true,
  });
})();
